import React from "react";
import { useIsAuthenticated } from "@azure/msal-react";
import LoginPage from "./LoginPage";
import MainUi from "./MainUi";

function App() {
  const isAuthenticated = useIsAuthenticated();

  return (
    <>
      {isAuthenticated ? <MainUi /> : <LoginPage />}
    </>
  );
}

export default App;
